export default {
    title: "Tanácsadói ajánlások",
    noItems: "Nincsenek ajánlások"
}